import { AbstractModel } from "../base"
import { FileAttachment } from "../file/file-attachment"
import type { IFileAttachment } from "../file/file-attachment.types"
import type { IDocument, IDocumentData } from "./document.types"
import { Tag } from "../tag/tag"
import type { ITag } from "../tag/tag.types"

export class Document extends AbstractModel implements IDocument {
  readonly id?: number
  readonly title: string
  readonly file: IFileAttachment
  readonly created?: Date
  readonly modified?: Date
  readonly tags: ITag[] = []

  constructor(data: IDocumentData) {
    super()

    // Validate data
    const requiredFields: (keyof IDocumentData)[] = ['title', 'file']
    this.validate(data, requiredFields)
    
    // Initialize object assuming data valid
    this.title = data.title!
    this.file = new FileAttachment(data.file!)

    if (data.id) {
      this.id = data.id
    }

    if (data.tags) {
      this.tags = data.tags.map((tag) => new Tag(tag))
    }

    if (data.created) {
      this.created =
        typeof data.created === 'string' ? new Date(data.created) : data.created
    }

    if (data.modified) {    
      this.modified =
        typeof data.modified === 'string' ? new Date(data.modified) : data.modified
    }
  }
}
